module.exports = __webpack_public_path__ + "img/9788982739323.b64836fd.jpg";